export default __webpack_public_path__ + "static/media/insight_select.939c117a.svg";